let initialData = [
]
export default initialData



/** WEBPACK FOOTER **
 ** ./reducers/initialData.js
 **/


/** WEBPACK FOOTER **
 ** ./reducers/initialData.js
 **/